import { createSelector } from 'reselect'

export const isPinnedSelector = createSelector(
  [
    state => state.userpins,
    (_, secondary_id) => secondary_id,
    (_, __, entityId) => entityId,
  ],
  (userpins, secondary_id, entityId) => {
    return userpins[secondary_id]?.[entityId] || null
  },
)

export const getSecondaryId = (entityType, entity) => {
  const entityTypeToEndpointMap = {
    template: entity.type === 'sms' ? 'sms/template' : 'email/template',
    form: 'customform',
    group: 'contactgroup',
  }
  return entityTypeToEndpointMap[entityType] || entityType
}